
/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
export const types_roles = [
  {
    name: 'AIRFRAMER',
  },
  {
    name: 'AIRLINE',
  },
  {
    name: 'APPRAISOR/CONSULTANT',
  },
  {
    name: 'BROKER/DISTRIBUTOR',
  },
  {
    name: 'GOVERNMENT AGENCY',
  },
  {
    name: 'LEASING COMPANY',
  },
  {
    name: 'MANUFACTURER',
  },
  {
    name: 'MILITARY',
  },
  {
    name: 'MILITARY US-AIR FORCE BASE',
  },
  {
    name: 'NON-REVENUE OPERATOR',
  },
  {
    name: 'OTHER',
  },
  {
    name: 'OVERHAUL/REPAIR',
  },
  {
    name: 'PARTNER',
  },
  {
    name: 'PRATT',
  },
  {
    name: 'REGULATORY AGENCY',
  },
  {
    name: 'SUPPLIER',
  },
  {
    name: 'UTILITY COMPANY',
  }
];

export const yes_or_no = [
  {
    label: 'Yes',
    id: 'yes'
  },
  {
    label: 'No',
    id: 'no'
  }]

export const no_or_yes = [
  {
    label: 'No',
    id: 'no'
  },
  {
    label: 'Yes',
    id: 'yes'
  }
  ]

  export const no_or_yes_bool = [
    {
      label: 'No',
      id: false
    },
    {
      label: 'Yes',
      id: true
    }
    ]

export const job_functions = [
  {
    name: 'AFTERMARKET SERVICES',
    value: 'AFTERMARKET SERVICES'
  },
  {
    name: 'AIRCRAFT ENGINEERING',
    value: 'AIRCRAFT ENGINEERING'
  },
  {
    name: 'AIRPORT OPERATIONS / FLIGHT OPERATIONS',
    value: 'AIRPORT OPERATIONS / FLIGHT OPERATIONS'
  },
  {
    name: 'BUSINESS DEVELOPMENT',
    value: 'BUSINESS DEVELOPMENT'
  },
  {
    name: 'COMMUNICATIONS / MEDIA',
    value: 'COMMUNICATIONS / MEDIA'
  },
  {
    name: 'CUSTOMER SERVICE',
    value: 'CUSTOMER SERVICE'
  },
  {
    name: 'EH&S',
    value: 'EH&S'
  },
  {
    name: 'ENGINEERING',
    value: 'ENGINEERING'
  },

    {
    name: 'EXECUTIVE MANAGEMENT',
    value: 'EXECUTIVE MANAGEMENT'
  },
  {
    name: 'FINANCE/ACCOUNTING',
    value: 'FINANCE/ACCOUNTING'
  },
  {
    name: 'IT / E-COMMERCE',
    value: 'IT / E-COMMERCE'
  },
  {
    name: 'LEGAL',
    value: 'LEGAL'
  },
  {
    name: 'MANUFACTURING OPERATIONS',
    value: 'MANUFACTURING OPERATIONS'
  },
  {
    name: 'MECHANICE/MAINTENANCE',
    value: 'MECHANICE/MAINTENANCE'
  },
  {
    name: 'PILOT',
    value: 'PILOT'
  },
  {
    name: 'PROJECT',
    value: 'PROJECT'
  },
  {
    name: 'PURCHASING/PROCUREMENT',
    value: 'PURCHASING/PROCUREMENT'
  },
  {
    name: 'QUALITY',
    value: 'QUALITY'
  },
  {
    name: 'SALES & MARKETING',
    value: 'SALES & MARKETING'
  }
]

export const title_options = [
  {
    name: 'Captain',
    value: 'captain'
  },
  {
    name: 'Dr.',
    value: 'dr'
  },
  {
    name: 'Miss',
    value: 'miss',
  },
  {
    name: 'Mr.',
    value: 'mr'
  },
  {
    name: 'Mrs.',
    value: 'mrs'
  },
  {
    name: 'Ms.',
    value: 'ms'
  },
  {
    name: 'None',
    value: ''
  }
]

/* export const engines = [
  'CFM56',
  'JT3D',
  'JT4A',
  'JT8D',
  'JT9D',
  'JT9D-7R4',
  'PW1100G-JM',
  'PW1200G',
  'PW1400G',
  'PW1500G',
  'PW1700G',
  'PW1900G',
  'PW2000',
  'PW4000-100',
  'PW4000-112',
  'PW4000-94',
  'PW6000',
  'V2500',
  'N/A'
] */

export const portals = [
  'EngineWise Connect'
]
  // {
  //   name: 'EngineWise Connect',
  //   value: 'EWC'
  // }
  
